<app-layout title="Gestión de Usuarios">
  <div class="bg-white text-dark p-4 rounded-bottom">

    <!-- Filtros de búsqueda -->
    <div class="row g-2 align-items-center mb-3 p-2">
      <div class="col-auto">
        <span class="ms-2">Registros:</span>

        <select id="pageSizeSelect" class="form-select w-auto d-inline-block" [(ngModel)]="pageSize"
          (change)="onPageSizeChange()">
          <option *ngFor="let size of [5, 10, 20, 50]" [value]="size">{{size}}</option>
        </select>
      </div>
      <div class="col-auto">
        <input type="text" class="form-control w-auto p-0" style="height: 38px;" placeholder="Nombre..."
          [(ngModel)]="name">
      </div>
      <div class="col-auto">
        <input type="text" class="form-control w-auto p-0" style="height: 38px;" placeholder="Email..."
          [(ngModel)]="email">
      </div>
      <div class="col-auto">
        <input type="text" class="form-control w-auto p-0" style="height: 38px;" placeholder="Rut..." [(ngModel)]="rut">
      </div>

      <!-- Select para Rol -->
      <div class="col-auto">
        <select class="form-select p-0" style="min-width: 170px; height: 38px;" [(ngModel)]="user_role">
          <option value="">Todos los Roles</option>
          <option *ngFor="let role of roles" [value]="role._id">{{ role.name }}</option>
        </select>
      </div>

      <!-- Select para Licencia Misionera -->
      <div class="col-auto">
        <select class="form-select p-0" style="min-width: 170px; height: 38px;" [(ngModel)]="missionary_license">
          <option value="">Todas las Licencias</option>
          <option *ngFor="let license of licenses" [value]="license._id">{{ license.name }}</option>
        </select>
      </div>

      <!-- Botón de búsqueda (más grande pero compacto) -->
      <div class="col-auto">
        <button class="btn btn-primary" style="padding: 0.45rem 1rem; height: 38px;"
          (click)="onSearch()">Buscar</button>
      </div>

      <!-- Botón para abrir modal separado a la derecha y más grande pero compacto -->
      <div class="col-auto ms-auto">
        <button class="btn btn-success" style="padding: 0.45rem 1rem; height: 38px;" data-bs-toggle="modal"
          data-bs-target="#userModal" (click)="openCreateModal()">
          Crear Usuario
        </button>
      </div>
    </div>

    <!-- Tabla de Usuarios (Sin ngx-pagination) -->
    <div class="table-responsive">
      <table class="table table-striped">
        <thead class="table-primary">
          <tr>
            <th>#</th>
            <th>Codigo del Empleado</th>
            <th>Nombre</th>
            <th>Email</th>
            <th>RUT</th>
            <th>Rol</th>
            <th>Licencia Misionera</th>
            <th>Activo</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of users; let i = index">
            <td>{{ (currentPage - 1) * pageSize + i + 1 }}</td>
            <td>{{ user.employee_code }}</td>
            <td>{{ user.name }}</td>
            <td>{{ user.email }}</td>
            <td>{{ user.rut }}</td>
            <td>{{ user.user_role?.name || 'Sin rol' }}</td>
            <td>{{ user.missionary_license?.name || 'Sin licencia' }}</td>
            <td>
              <span class="badge" [ngClass]="user.active ? 'bg-success' : 'bg-secondary'">
                {{ user.active ? 'Sí' : 'No' }}
              </span>
            </td>
            <td>
              <button class="btn btn-sm btn-warning" (click)="openEditModal(user)">
                <i class="bi bi-pencil-square"></i>
              </button>
              <button class="btn btn-sm btn-danger"><i class="bi bi-trash"></i></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    

    <!-- Controles de paginación -->
    <div class="d-flex justify-content-center mt-3">
      <!-- Paginador Manual -->
      <nav>
        <ul class="pagination justify-content-center mt-3">
          <li class="page-item" [class.disabled]="currentPage === 1">
            <a class="page-link" (click)="changePage(currentPage - 1)">Anterior</a>
          </li>

          <li *ngFor="let page of getPaginationArray()" class="page-item" [class.active]="currentPage === page">
            <a class="page-link" (click)="changePage(page)">{{ page }}</a>
          </li>

          <li class="page-item" [class.disabled]="currentPage === totalPages">
            <a class="page-link" (click)="changePage(currentPage + 1)">Siguiente</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>


  <div class="modal fade" id="userModal" tabindex="-1" aria-labelledby="userModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="userModalLabel">{{ isEdit ? 'Editar Usuario' : 'Crear Usuario' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="closeModal()"></button>
        </div>
        <div class="modal-body">
          <form [formGroup]="userForm">
            <div class="mb-3">
              <label class="form-label">Nombre</label>
              <input type="text" class="form-control" formControlName="name" placeholder="Ingrese el nombre">
            </div>
            <div class="mb-3">
              <label class="form-label">RUT</label>
              <input type="text" class="form-control" formControlName="rut" placeholder="Ingrese el RUT">
            </div>
            <div class="mb-3">
              <label class="form-label">Código de Empleado</label>
              <input type="number" class="form-control" formControlName="employee_code"
                placeholder="Ingrese el código de empleado">
            </div>
            <div class="mb-3">
              <label class="form-label">Email</label>
              <input type="email" class="form-control" formControlName="email" placeholder="Ingrese el email">
            </div>
            <div class="mb-3">
              <label class="form-label">Rol</label>
              <select class="form-select" formControlName="user_role">
                <option *ngFor="let role of roles" [value]="role._id">{{ role.name }}</option>
              </select>
            </div>
            <div class="mb-3">
              <label class="form-label">Licencia Misionera</label>
              <select class="form-select" formControlName="missionary_license">
                <option value="">Ninguna</option>
                <option *ngFor="let license of licenses" [value]="license._id">{{ license.name }}</option>
              </select>
            </div>
            <div class="mb-3">
              <label class="form-label">Activo</label>
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" formControlName="active" id="activeSwitch">
                <label class="form-check-label" for="activeSwitch">
                  {{ userForm.get('active')?.value ? 'Sí' : 'No' }}
                </label>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label">Clave</label>
              <input [type]="showPassword ? 'text' : 'password'" class="form-control" formControlName="password" placeholder="Ingrese la clave">
              <div class="d-flex justify-content-end mt-1">
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="showPassword = !showPassword">
                  <i class="fas" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                  {{ showPassword ? 'Ocultar' : 'Mostrar' }}
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
            (click)="closeModal()">Cancelar</button>
          <button type="button" class="btn btn-primary" (click)="saveUser()">{{ isEdit ? 'Actualizar' : 'Guardar'
            }}</button>
        </div>
      </div>
    </div>
  </div>
</app-layout>